import styled from 'styled-components';

interface StyledChatMessageBubbleProps {
  $fromUser: boolean;
  $backgroundColor: string;
}

const StyledChatMessageBubble = styled.div<StyledChatMessageBubbleProps>`
  background-color: ${(props) => (props.$fromUser && props.$backgroundColor) ? props.$backgroundColor : '#F5F5F5'};
  color: ${(props) => props.$fromUser ? '#fff' : '#000'};
  border-radius: 8px;
  padding: 18px;
  display: inline-block;
  align-self: ${(props) => props.$fromUser ? 'end' : 'start'};
`;

export default StyledChatMessageBubble;